module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm03"
    }
  }), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('em', [_vm._v("Also by Mo Hayder")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("BIRDMAN"), _c('br'), _vm._v("THE TREATMENT"), _c('br'), _vm._v("TOKYO")]), _vm._v(" "), _c('p', {
    staticClass: "centerk"
  }, [_c('em', [_vm._v("For more information on Mo Hayder and her books, see her website at "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.mohayder.net",
      "target": "_blank"
    }
  }, [_vm._v("www.mohayder.net")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3212f3f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm03.vue
// module id = 69
// module chunks = 0